import ApplicationSerializer from './application';

export default class StatisticSerializer extends ApplicationSerializer {
}
